<template>
  <div :class="$style.wrapper">
    <h2 :class="$style.title">SNKRROOM</h2>
    <p :class="$style.subtitle">
      Профессиональная информационная ресейл-платформа
    </p>

    <div :class="[$style.video, isFullscreen && $style.videoFullscreen]">
      <video
        ref="videoElement"
        autoplay
        loop
        playsinline
        preload="auto"
        @loadeddata="onVideoLoaded"
        @canplay="onVideoCanPlay"
      >
        <source src="@/assets/video/preview.webm" type="video/webm" />
        <source src="@/assets/video/preview.mp4" type="video/mp4" />
      </video>
      <button
        type="button"
        :class="$style.soundButton"
        @click="toggleSound"
        :aria-label="isMuted ? 'Включить звук' : 'Выключить звук'"
      >
        <svg
          v-if="isMuted"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
          <line x1="23" y1="9" x2="17" y2="15"></line>
          <line x1="17" y1="9" x2="23" y2="15"></line>
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
          <path
            d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"
          ></path>
        </svg>
      </button>
      <button
        type="button"
        :class="$style.fullscreenButton"
        @click="toggleFullscreen"
        aria-label="Открыть видео во весь экран"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
          ></path>
        </svg>
      </button>
    </div>

    <div :class="$style.selects">
      <label :class="[$style.card, role === 'seller' && $style.cardActive]">
        <input
          type="radio"
          name="role"
          value="seller"
          v-model="role"
          :class="$style.visuallyHidden"
        />
        <span :class="[$style.radio, role === 'seller' && $style.radioActive]">
          <span v-if="role === 'seller'" :class="$style.radioDot"></span>
        </span>
        <div :class="$style.cardBody">
          <div :class="$style.cardTitle">Селлер</div>
          <div :class="$style.cardDesc">
            Подходит для тех, кто хочет продать свои кроссовки
          </div>
        </div>
      </label>

      <label :class="[$style.card, role === 'reseller' && $style.cardActive]">
        <input
          type="radio"
          name="role"
          value="reseller"
          v-model="role"
          :class="$style.visuallyHidden"
        />
        <span
          :class="[$style.radio, role === 'reseller' && $style.radioActive]"
        >
          <span v-if="role === 'reseller'" :class="$style.radioDot"></span>
        </span>
        <div :class="$style.cardBody">
          <div :class="$style.cardTitle">Реселлер</div>
          <div :class="$style.cardDesc">
            Подходит для тех, кто решил купить кроссовки на перепродажу
          </div>
        </div>
      </label>
    </div>

    <div :class="$style.checkboxes">
      <label :class="$style.checkRow">
        <input
          type="checkbox"
          v-model="agreeRules"
          :class="$style.visuallyHidden"
        />
        <span :class="[$style.check, agreeRules && $style.checkOn]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="10"
            viewBox="0 0 11 10"
            fill="none"
            :class="$style.checkIcon"
            aria-hidden="true"
          >
            <path
              d="M4.02609 9.83497C3.72991 9.83497 3.47816 9.7082 3.27084 9.45464L0.394192 5.93792C0.312743 5.84238 0.253507 5.74867 0.216484 5.6568C0.183164 5.56493 0.166504 5.46939 0.166504 5.37017C0.166504 5.14969 0.240549 4.96779 0.388639 4.82447C0.536728 4.68116 0.723692 4.6095 0.949529 4.6095C1.20498 4.6095 1.41971 4.71791 1.59372 4.93472L4.00388 7.96637L8.70758 0.569131C8.80384 0.422142 8.9038 0.31925 9.00746 0.260454C9.11113 0.197983 9.2407 0.166748 9.3962 0.166748C9.62204 0.166748 9.80715 0.236568 9.95154 0.376208C10.0959 0.515848 10.1681 0.694072 10.1681 0.910882C10.1681 0.999075 10.1533 1.08727 10.1237 1.17546C10.0941 1.26366 10.0478 1.35552 9.98486 1.45107L4.7869 9.43259C4.6092 9.70085 4.35559 9.83497 4.02609 9.83497Z"
              fill="white"
              stroke="white"
              stroke-width="0.333387"
            />
          </svg>
        </span>
        <span :class="$style.checkText">
          Я согласен с
          <router-link
            to="/docs/rules"
            :class="$style.link"
            @click="hideMainButton"
            >Правилами платформы</router-link
          >
        </span>
      </label>

      <label :class="$style.checkRow">
        <input
          type="checkbox"
          v-model="agreePrivacy"
          :class="$style.visuallyHidden"
        />
        <span :class="[$style.check, agreePrivacy && $style.checkOn]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="10"
            viewBox="0 0 11 10"
            fill="none"
            :class="$style.checkIcon"
            aria-hidden="true"
          >
            <path
              d="M4.02609 9.83497C3.72991 9.83497 3.47816 9.7082 3.27084 9.45464L0.394192 5.93792C0.312743 5.84238 0.253507 5.74867 0.216484 5.6568C0.183164 5.56493 0.166504 5.46939 0.166504 5.37017C0.166504 5.14969 0.240549 4.96779 0.388639 4.82447C0.536728 4.68116 0.723692 4.6095 0.949529 4.6095C1.20498 4.6095 1.41971 4.71791 1.59372 4.93472L4.00388 7.96637L8.70758 0.569131C8.80384 0.422142 8.9038 0.31925 9.00746 0.260454C9.11113 0.197983 9.2407 0.166748 9.3962 0.166748C9.62204 0.166748 9.80715 0.236568 9.95154 0.376208C10.0959 0.515848 10.1681 0.694072 10.1681 0.910882C10.1681 0.999075 10.1533 1.08727 10.1237 1.17546C10.0941 1.26366 10.0478 1.35552 9.98486 1.45107L4.7869 9.43259C4.6092 9.70085 4.35559 9.83497 4.02609 9.83497Z"
              fill="white"
              stroke="white"
              stroke-width="0.333387"
            />
          </svg>
        </span>
        <span :class="$style.checkText">
          Я согласен с
          <router-link
            to="/docs/personal-data"
            :class="$style.link"
            @click="hideMainButton"
            >Политикой обработки персональных данных</router-link
          >
        </span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      role: "seller",
      agreeRules: false,
      agreePrivacy: false,
      videoLoaded: false,
      isMuted: false,
      isFullscreen: false,
    }
  },
  computed: {
    bothAgree() {
      return this.agreeRules && this.agreePrivacy
    },
  },
  watch: {
    bothAgree: {
      handler(val) {
        const tg = window.Telegram?.WebApp
        const mb = tg?.MainButton
        if (!mb) return
        if (val) {
          mb.textColor = "#ffffff"
          mb.color = "#eb5a0a"
        } else {
          mb.textColor = "#B9B9BB"
          mb.color = "#E8E8EA"
        }
      },
      immediate: true,
    },
    "$route.name": {
      handler(newRoute, oldRoute) {
        // Если вернулись на страницу Register, показываем MainButton обратно
        if (newRoute === "Register" && oldRoute !== "Register") {
          this.$nextTick(() => {
            this.bindMainButton()
          })
        }
      },
      immediate: false,
    },
  },
  methods: {
    onVideoLoaded() {
      this.videoLoaded = true
      // Принудительно запускаем воспроизведение со звуком
      if (this.$refs.videoElement) {
        const video = this.$refs.videoElement
        // Убеждаемся, что звук включен
        video.muted = false
        video.volume = 1.0
        this.isMuted = false
        video.play().catch((error) => {
          // Если autoplay со звуком заблокирован, пробуем с muted
          console.warn(
            "Autoplay со звуком заблокирован, пробуем с muted:",
            error
          )
          video.muted = true
          this.isMuted = true
          video
            .play()
            .then(() => {
              // После начала воспроизведения включаем звук
              video.muted = false
              this.isMuted = false
            })
            .catch(() => {
              // Если и это не сработало, оставляем muted
              console.warn("Не удалось запустить видео автоматически")
            })
        })
      }
    },
    onVideoCanPlay() {
      // Видео готово к воспроизведению
      if (this.$refs.videoElement && !this.videoLoaded) {
        const video = this.$refs.videoElement
        video.muted = false
        video.volume = 1.0
        this.isMuted = false
        video.play().catch((error) => {
          console.warn("Autoplay со звуком заблокирован:", error)
          video.muted = true
          this.isMuted = true
          video
            .play()
            .then(() => {
              video.muted = false
              this.isMuted = false
            })
            .catch(() => {
              console.warn("Не удалось запустить видео автоматически")
            })
        })
      }
    },
    toggleSound() {
      if (this.$refs.videoElement) {
        const video = this.$refs.videoElement
        this.isMuted = !this.isMuted
        video.muted = this.isMuted
      }
    },
    toggleFullscreen() {
      const tg = window.Telegram?.WebApp
      const mb = tg?.MainButton
      const video = this.$refs.videoElement

      if (!video) return

      if (this.isFullscreen) {
        // Выходим из полноэкранного режима
        this.isFullscreen = false

        // Показываем MainButton обратно
        if (mb) {
          mb.show()
        }

        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => {
            console.warn("Не удалось выйти из полноэкранного режима:", err)
          })
        } else if (document.webkitFullscreenElement) {
          document.webkitExitFullscreen?.()
        } else if (document.mozFullScreenElement) {
          document.mozCancelFullScreen?.()
        } else if (document.msFullscreenElement) {
          document.msExitFullscreen?.()
        }

        // После выхода из полноэкранного режима видео делаем мини-апп в фуллскрин
        if (tg && tg.requestFullscreen) {
          try {
            tg.requestFullscreen()
          } catch (err) {
            console.warn(
              "Ошибка при открытии WebApp в полноэкранном режиме:",
              err
            )
          }
        }
      } else {
        // Входим в полноэкранный режим
        this.isFullscreen = true

        // Скрываем MainButton при открытии видео во весь экран
        if (mb) {
          mb.hide()
        }

        // В Telegram WebApp сначала открываем WebApp в полноэкранном режиме
        if (tg && tg.requestFullscreen) {
          try {
            tg.requestFullscreen()
          } catch (err) {
            console.warn(
              "Ошибка при открытии WebApp в полноэкранном режиме:",
              err
            )
          }
        }

        // Пытаемся открыть видео в полноэкранном режиме
        if (video.requestFullscreen) {
          video.requestFullscreen().catch((err) => {
            console.warn("Не удалось открыть видео во весь экран:", err)
            // Если не удалось, используем CSS полноэкранный режим
          })
        } else if (video.webkitRequestFullscreen) {
          // Для Safari
          video.webkitRequestFullscreen().catch((err) => {
            console.warn(
              "Не удалось открыть видео во весь экран (webkit):",
              err
            )
          })
        } else if (video.mozRequestFullScreen) {
          // Для Firefox
          video.mozRequestFullScreen().catch((err) => {
            console.warn("Не удалось открыть видео во весь экран (moz):", err)
          })
        } else if (video.msRequestFullscreen) {
          // Для IE/Edge
          video.msRequestFullscreen().catch((err) => {
            console.warn("Не удалось открыть видео во весь экран (ms):", err)
          })
        }
      }

      // Слушаем события выхода из полноэкранного режима
      const handleFullscreenChange = () => {
        if (
          !document.fullscreenElement &&
          !document.webkitFullscreenElement &&
          !document.mozFullScreenElement &&
          !document.msFullscreenElement
        ) {
          this.isFullscreen = false

          // Показываем MainButton обратно
          if (mb) {
            mb.show()
          }

          // После выхода из полноэкранного режима видео делаем мини-апп в фуллскрин
          if (tg && tg.requestFullscreen) {
            try {
              tg.requestFullscreen()
            } catch (err) {
              console.warn(
                "Ошибка при открытии WebApp в полноэкранном режиме:",
                err
              )
            }
          }

          document.removeEventListener(
            "fullscreenchange",
            handleFullscreenChange
          )
          document.removeEventListener(
            "webkitfullscreenchange",
            handleFullscreenChange
          )
          document.removeEventListener(
            "mozfullscreenchange",
            handleFullscreenChange
          )
          document.removeEventListener(
            "MSFullscreenChange",
            handleFullscreenChange
          )
        }
      }

      document.addEventListener("fullscreenchange", handleFullscreenChange)
      document.addEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      )
      document.addEventListener("mozfullscreenchange", handleFullscreenChange)
      document.addEventListener("MSFullscreenChange", handleFullscreenChange)
    },
    hideMainButton() {
      const tg = window.Telegram?.WebApp
      const mb = tg?.MainButton
      if (mb) {
        mb.hide()
      }
    },
    apply() {
      this.$store.commit("changeUserInfoUpdate", { type: this.role })
      if (this.role === "seller") this.$router.push("/select-delivery-time")
      else if (this.role === "reseller") this.$router.push("/filling-data")
    },
    bindMainButton() {
      const tg = window.Telegram?.WebApp
      const mb = tg?.MainButton
      if (!tg || !mb) return
      if (tg.__mbOnClick) {
        try {
          mb.offClick(tg.__mbOnClick)
        } catch (e) {
          window.console.log(e)
        }
        tg.__mbOnClick = null
      }
      const handler = () => {
        if (!this.bothAgree) return
        this.apply()
      }
      tg.__mbOnClick = handler
      mb.onClick(handler)
      mb.setText("Далее")
      mb.show()
      if (this.bothAgree) {
        mb.textColor = "#ffffff"
        mb.color = "#eb5a0a"
      } else {
        mb.textColor = "#B9B9BB"
        mb.color = "#E8E8EA"
      }
    },
  },
  mounted() {
    this.bindMainButton()
  },
  beforeUnmount() {
    const tg = window.Telegram?.WebApp
    const mb = tg?.MainButton
    if (tg?.__mbOnClick && mb) {
      try {
        mb.offClick(tg.__mbOnClick)
      } catch (e) {
        window.console.log(e)
      }
      tg.__mbOnClick = null
    }
  },
}
</script>

<style lang="scss" module>
.wrapper {
  --accent: #eb5a0a;
  --text: #161616;
  --muted: #6b6b6f;
  --card: #f6f6f7;
  --border: #ececee;
  padding: 0.5rem 1rem 4rem 1rem;
}
.title {
  margin: 1rem 0 0 0;
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 1.2;
  color: var(--text);
  text-align: center;
}
.subtitle {
  margin-top: 0.5rem;
  color: var(--muted);
  font-size: 1.125rem;
  line-height: 1.4;
  text-align: center;
}
.video {
  margin-top: 1.5rem;
  width: 100%;
  height: 12.5rem;
  background: #000000;
  border-radius: 0.5rem;
  position: relative;
  transition: all 0.3s ease;
}
.videoFullscreen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  margin: 0;
  border-radius: 0;
  z-index: 10000;
}
.video video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.5rem;
  transition: border-radius 0.3s ease;
}
.videoFullscreen video {
  border-radius: 0;
  object-fit: contain;
}
.soundButton {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #ffffff;
  transition: background-color 0.2s ease;
  z-index: 10;
}
.soundButton:hover {
  background: rgba(0, 0, 0, 0.7);
}
.soundButton:active {
  background: rgba(0, 0, 0, 0.9);
}
.soundButton svg {
  width: 1.25rem;
  height: 1.25rem;
}
.fullscreenButton {
  position: absolute;
  bottom: 0.5rem;
  right: 0.5rem;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #ffffff;
  transition: background-color 0.2s ease;
  z-index: 10;
}
.fullscreenButton:hover {
  background: rgba(0, 0, 0, 0.7);
}
.fullscreenButton:active {
  background: rgba(0, 0, 0, 0.9);
}
.fullscreenButton svg {
  width: 1.25rem;
  height: 1.25rem;
}
.selects {
  margin-top: 1.25rem;
  display: grid;
  gap: 0.5rem;
}
.visuallyHidden {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 0;
  height: 0;
}
.card {
  display: grid;
  grid-template-columns: 1.25rem 1fr;
  gap: 1rem;
  align-items: center;
  background: var(--card);
  border-radius: 0.625rem;
  padding: 0.625rem 1rem;
  transition: border-color 0.2s, background-color 0.2s;
  user-select: none;
}
.cardActive {
  border-color: rgba(235, 90, 10, 0.25);
}
.radio {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  border: 1px solid #dbdbdf;
  display: grid;
  place-items: center;
  background: #fff;
  transition: all 0.2s ease;
}
.radioActive {
  border-color: var(--accent);
  transition: all 0.2s ease;
}
.radioDot {
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  background: var(--accent);
  transition: all 0.2s ease;
}
.cardBody {
  display: grid;
  gap: 0.25rem;
}
.cardTitle {
  font-weight: 700;
  color: var(--text);
  font-size: 1rem;
}
.cardDesc {
  color: var(--muted);
  font-size: 0.875rem;
  line-height: 1.35;
}
.checkboxes {
  margin-top: 1.625rem;
  display: grid;
  gap: 14px;
}
.checkRow {
  display: grid;
  grid-template-columns: 1.25rem 1fr;
  gap: 1rem;
  align-items: start;
}
.check {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: var(--accent);
  color: #fff;
  transform: translateY(0.125rem);
}
.checkIcon {
  width: 0.625rem;
  height: 0.625rem;
}
.checkText {
  font-size: 1rem;
  color: var(--text);
  line-height: 1.35;
}
.link {
  color: var(--accent);
  text-decoration: underline;
  text-underline-offset: 1px;
}
.checkRow input:not(:checked) + .check {
  background: #ffffff;
  color: transparent;
  outline: 1px solid var(--accent);
  outline-offset: -1px;
}
.checkOn {
  background: var(--accent) !important;
  color: #fff !important;
}
</style>
